const LOG_LEVELS = [ 'debug', 'warn', 'error' ]
export function createLog( level, module ) {
  return ( message, ...rest ) => {
    // eslint-disable-next-line no-console
    console[level]( module ? `[${module}] ${message}` : message, ...rest )
  }
}

export function createLogs( module ) {
  return LOG_LEVELS.reduce( ( prev, curr ) => {
    prev[curr] = createLog( curr, module )

    return prev
  }, {} )
}
